import { useCallback, useState } from "react";
import { CategoriesService } from "../../../../../core/http/services/CategoriesService";

const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ type: null, message: null });

  const fetchCategories = useCallback(async () => {
    setLoading(true);
    setError({ type: null, message: null });

    const { status, data, message } = await CategoriesService.get();

    if (status !== 200) {
      setError({ type: "categories", message });
      setLoading(false);
      return;
    }

    setCategories(data ?? []);
    setLoading(false);
  }, []);

  return { categories, setCategories, loading, error, fetchCategories };
};

export default useCategories;
